<template>
  <el-dialog
    :visible.sync="dialogTableVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="2%"
    @close="handleClose"
  >
    <span slot="title" class="dialog-title">开通正式版</span>
    <div class="pan-thumb-box" v-loading="loading">
      <div class="pan-thumb-info">
        <div class="pan-thumb-info-text">
          <span style="color: #ff4646">*</span>
          <span> 机构选择：</span>
          <el-radio
            v-model="radio"
            :label="item.value"
            v-for="item in radioButton"
            :key="item.value"
            @change="handleChange(item)"
            >{{ item.label }}</el-radio
          >
        </div>
        <div
          class="pan-thumb-info-text"
          v-if="radio === '00000000-0000-0000-0000-000000000000'"
        >
          <span style="color: #ff4646">*</span>
          <span> 机构选择：</span>
          <el-select
            v-model="value"
            filterable
            placeholder="请选择"
            style="width: 50%"
            @change="handleEnterpriseChange"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="pan-thumb-info-btn-box">
          <div
            class="pan-thumb-info-btn-item"
            v-for="(item, index) in projects"
            :key="index"
          >
            <div
              :class="[
                'pan-thumb-info-btn',
                { isText: item.hasDiscount },
                { gray: !item.enabled },
              ]"
            >
              <div class="pan-thumb-info-btn-top">
                <span class="pan-thumb-info-btn-pay">{{ item.priceStr }}</span>
                <span style="margin-top: 10px">/{{ item.unit }}</span>
              </div>
              <div class="pan-thumb-info-btn-desc" v-if="item.hasDiscount">
                <span style="font-size: 15px">{{
                  item.beforeDiscountPrice
                }}</span>
                <span style="font-size: 10px">/{{ item.unit }}</span>
                <div class="pan-thumb-info-btn-desc-line"></div>
              </div>
              <img
                v-if="item.enabled"
                class="pan-thumb-info-btn-img"
                src="@/assets/purchase/pay-icon.png"
              />
            </div>
            <div
              :class="['pan-thumb-info-btn-text', { gray: !item.enabled }]"
              v-if="item.hasDiscount"
            >
              {{ item.discountDescription }}
            </div>
          </div>
        </div>
        <div class="pan-thumb-info-text">
          <span>开通内容：{{ payInfo.projectName }}</span>
        </div>
        <div class="pan-thumb-info-text">
          <span>有效期至：{{ payInfo.validEnd }}</span>
        </div>
        <div class="pan-thumb-info-text">
          <span
            >应付金额：<span style="color: #fd5f39; font-size: 16px">{{
              payInfo.price
            }}</span
            >元</span
          >
        </div>
        <div class="pan-thumb-info-button" v-if="radioButton.length === 2">
          <el-button type="primary" @click="handleCreateOrder" size="mini">
            <i class="el-icon-refresh"></i>
            订单
          </el-button>
        </div>
      </div>
      <div class="pan-thumb-pay" v-if="isOrder">
        <!-- <div class="pan-thumb-pay-text-box">
          <div class="pan-thumb-pay-text">支付方式：</div>
          <div class="pan-thumb-pay-text-btn">
            <span>微信支付</span>
            <img
              class="pan-thumb-pay-text-btn-img"
              src="@/assets/purchase/pay-icon.png"
            />
          </div>
        </div> -->
        <div class="pan-thumb-pay-code-box">
          <div class="pan-thumb-pay-code-text">
            <img
              class="pay-code-text-img"
              src="@/assets/purchase/pay.png"
              alt=""
            />
            <div class="pay-code-text-right">
              <div class="pay-code-text-right-title">微信支付</div>
              <div class="pay-code-text-right-value">使用微信扫码支付</div>
            </div>
          </div>
          <div class="pan-thumb-pay-code">
            <img
              :class="['pan-thumb-pay-code-img', { expired: isExpired }]"
              :src="orderInfo.codeUrl"
              alt=""
            />
            <div v-if="!isExpired">打开手机端微信</div>
            <div v-if="!isExpired">扫一扫继续付款</div>
            <div v-if="isExpired" style="margin-top: 11px">
              二维码已失效，请重新获取
            </div>
            <div
              v-if="isExpired"
              style="color: #4076f2; cursor: pointer; margin-top: 5px"
              @click="handleCreateOrder"
            >
              点击请重新获取二维码
            </div>
          </div>
          <div class="pan-thumb-pay-tip">
            请您在<span style="color: #ff0909">{{ countdown }}</span
            >s内完成支付，否则二维码将失效
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "Purchase",
  props: {},
  data() {
    return {
      dialogTableVisible: false,
      loading: false,
      isOrder: false,
      radio: "",
      value: "",
      enterpriseId: "",
      radioButton: [],
      payInfo: {},
      projects: [],
      options: [],
      orderInfo: {},
      isExpired: false,
      timer: null,
      countdownTimer: null,
      countdown: 120,
    };
  },
  methods: {
    handleClose() {
      clearInterval(this.timer);
      clearInterval(this.countdownTimer);
      this.countdown = 120;
    },
    handleEnterpriseChange(item) {
      clearInterval(this.timer);
      clearInterval(this.countdownTimer);
      this.isOrder = false;
      let enterprise = this.options.find((i) => i.value === item);
      this.payInfo = enterprise.projects[0];
      this.projects = enterprise.projects;
    },
    handleChange(item) {
      clearInterval(this.timer);
      clearInterval(this.countdownTimer);
      this.isOrder = false;
      if (item.value === "00000000-0000-0000-0000-000000000000") {
        this.value = this.options[0].value;
        this.payInfo = this.options[0].projects[0];
        this.projects = this.options[0].projects;
      } else {
        this.payInfo = item.projects[0];
        this.projects = item.projects;
      }
    },
    async handleCreateOrder() {
      this.loading = true;
      const { data } = await this.$api.order.CreateOrder({
        loginEnterpriseId: this.enterpriseId,
        enterpriseId: this.payInfo.value,
        projectId: this.payInfo.projectId,
      });
      this.loading = false;
      this.orderInfo = data;
      this.isExpired = false;
      this.isOrder = true;
      clearInterval(this.timer);
      clearInterval(this.countdownTimer);
      this.countdown = 120;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.countdownTimer);
          this.isExpired = true;
        }
      }, 1000);
      this.searchOrderStatus();
    },
    async searchOrderStatus() {
      this.timer = setInterval(async () => {
        const { data } = await this.$api.order.WeChatOrder({
          uniqueOrderNumber: this.orderInfo.uniqueOrderNumber,
        });
        if (data) {
          clearInterval(this.timer);
          this.dialogTableVisible = false;
          this.$emit("successPay");
        }
      }, 2000);
    },
    async show(enterpriseId) {
      this.enterpriseId = enterpriseId;
      this.dialogTableVisible = true;
      this.isOrder = false;
      this.loading = true;
      const { data } = await this.$api.order.BeforeCreateOrderV2({
        loginEnterpriseId: this.enterpriseId,
      });
      this.loading = false;
      this.radioButton = data.radioButton;
      this.radio = data.radioButton[0].value;
      this.payInfo = data.radioButton[0].projects[0];
      this.projects = data.radioButton[0].projects;
      this.options = data.enterpriseStoreList;
      if (data.radioButton.length === 1) {
        this.handleCreateOrder();
      }
    },
  },
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background: #f6f8ff !important;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
</style>
<style lang="scss" scoped>
@import "./index.scss";
</style>
